import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardHeader } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DehazeIcon from '@mui/icons-material/Dehaze';
import AssetImage from '../../../common/asset/AssetImage';
import CustomButton from '../../../common/CustomButton';
const MediaCard = ({ courseData }) => {
    const { instructors, } = courseData;
    return (_jsxs(Card, { sx: {
            width: '316px', boxShadow: 0, p: 2, minHeight: 351,
        }, children: [_jsx(CardHeader, { title: (_jsx(Typography, { variant: "subtitle1", fontWeight: "fontWeightBold", sx: {
                        opacity: 0.9, width: '300px', minHeight: '56px',
                    }, children: courseData?.name })), subheader: (_jsx(Typography, { variant: "caption", sx: { opacity: 0.7 }, children: `By ${instructors?.[0]?.name}` })), sx: { p: 0 } }), _jsx(CardContent, { sx: {
                    p: 0,
                    my: 2,
                    width: '100%',
                    paddingTop: '56.25%',
                    position: 'relative',
                }, children: _jsx(AssetImage, { asset: courseData.courseImage, customStyle: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        width: '100%',
                        height: '100%',
                    }, size: "thumb400w" }) }), _jsxs(CardActions, { sx: { px: 0, display: 'flex', justifyContent: 'center' }, children: [_jsx(CustomButton, { startIcon: _jsx(AddIcon, {}), label: "ADD TO LIST", customStyle: { width: 120 }, onClick: () => { } }), _jsx(CustomButton, { startIcon: _jsx(DehazeIcon, {}), label: "EXPLORE", customStyle: { width: 120 }, onClick: () => { } })] })] }));
};
export default MediaCard;
//# sourceMappingURL=MediaCard.js.map